import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import containerTypeRequests from 'app/requests/ContainerType.requests'

import {
    ContainerType,
} from '../../Containers/containers.types'

const useGetContainerTypes = (params: Record<string, any> = {}) => {
    const {
        data: containerTypes,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<ContainerType[]>({
        key: RequestKeys.getContainerTypes,
        requestFunc: RequestFn.getEntity(
            containerTypeRequests[RequestKeys.getContainerTypes], (promise) => {
                return promise.then((resp) => {
                    return resp?.data?.items
                })
            },
        ),
        params,
        staleTime: Infinity,
        keepPreviousData: true,
    })

    return {
        containerTypes,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetContainerTypes
